const useFormPage1 = ({ dispatch, ACTIONS }) => {
  const auditLCPSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_LCP,
      value: selectedOption,
    });
  };

  const auditMarketSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_MARKET,
      value: selectedOption,
    });
  };

  const auditContractorSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_CONTRACTOR,
      value: selectedOption,
    });
  };

  const auditInHouseSplicerSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_IN_HOUSE_SPLICER,
      value: selectedOption,
    });
  };

  const auditCrewSelectHandler = (selectedOption) => {
    dispatch({
      type: ACTIONS.SET_CREW,
      value: selectedOption,
    });
  };

  const convertContractorsHandler = (data) => {
    return data?.map((option) => {
      return { value: option, label: `${option?.LEGAL_NAME}` };
    });
  };

  const convertInHouseSplicersHandler = (data) => {
    return data?.map((option) => {
      return { value: option, label: `${option?.name}` };
    });
  };

  const convertCrewHandler = (data) => {
    return data
      ?.map((option) => {
        return { value: option, label: `${option.FOREMAN}` };
      })
      .sort((a, b) => (a.FOREMAN > b.FOREMAN ? 1 : -1));
  };

  const convertMarketHandler = (data) => {
    let options = data?.map((option) => {
      return { value: option, label: option?.AREANAME };
    });
    if (process.env?.REACT_APP_MODE !== "prod") {
      options.unshift({
        value: { AREANAME: "Test", GLOBALID: "N/A" },
        label: "Test",
      });
    }
    return options;
  };

  const convertAreanameHandler = (data) => {
    let options = data?.map((option) => {
      return { value: option, label: option?.AREANAME };
    });
    options.unshift({
      value: { AREANAME: "Not Listed", GLOBALID: "N/A" },
      label: "Not Listed",
    });
    return options;
  };

  return {
    auditCrewSelectHandler,
    auditContractorSelectHandler,
    auditLCPSelectHandler,
    auditMarketSelectHandler,
    convertContractorsHandler,
    convertMarketHandler,
    convertAreanameHandler,
    convertCrewHandler,
    convertInHouseSplicersHandler,
    auditInHouseSplicerSelectHandler,
  };
};

export default useFormPage1;
